import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './product-card.component.scss';
var ProductCard = /** @class */ (function (_super) {
    tslib_1.__extends(ProductCard, _super);
    function ProductCard(element) {
        return _super.call(this, element) || this;
    }
    ProductCard.prototype.init = function () {
    };
    ProductCard.prototype.bindEvents = function () {
    };
    return ProductCard;
}(Base));
export { ProductCard };



//////////////////
// WEBPACK FOOTER
// ./components/product-card/product-card.component.ts
// module id = 442
// module chunks = 0